/*
 * The small pieces of ARIA plumbing the control layer shares.
 *
 * These live outside any one component because more than one of them needs the
 * same behaviour, and a copy per component is how two controls end up
 * describing themselves differently for no reason anybody can later reconstruct.
 */

/**
 * Joins `aria-describedby` ids, dropping the ones that are not there.
 *
 * A control here can be described by several things at once: a Field hint, a
 * Field error, a Textarea character counter, and whatever the caller passed in.
 * Assembling that with a template string leaves either a stray space or the
 * literal token `undefined`, and an id that resolves to no element is not an
 * error a browser reports: the description is simply dropped, silently, and the
 * hint you can see on screen is never read aloud.
 */
export function joinIds(...ids: Array<string | undefined | false | null>): string | undefined {
  const present = ids.filter((id): id is string => typeof id === 'string' && id.length > 0)
  return present.length > 0 ? present.join(' ') : undefined
}
